import { useEffect, useMemo } from 'react'
import useStateWithChange from '@/shared/hooks/useStateWithChange'
import { IUser, IUserInfo } from '@/pages/Users/users.types'

interface IProps {
  user: IUser
}

const useAccountSettingsCtrl = (props: IProps) => {
  const [userInfoDraft, setUserInfoDraft, handleUserInfoDraftChange] = useStateWithChange<IUserInfo>({
    firstName: '',
    lastName: '',
    middleName: '',
    phoneNumber: '',
    telegram: '',
    avatar: null,
  })

  useEffect(() => {
    if (!props.user.userInfo) return
    setUserInfoDraft(props.user.userInfo)
  }, [props.user])

  const isUserDraftChanged = useMemo(() => {
    for (let key in props.user.userInfo) {
      if (key !== 'avatar' && props.user.userInfo[key] !== userInfoDraft[key]) return true
    }
    return false
  }, [userInfoDraft, props.user.userInfo])

  return {
    isUserDraftChanged,
    userInfoDraft,
    handleUserInfoDraftChange,
    setUserInfoDraft,
  }
}

export default useAccountSettingsCtrl
